var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHotelroominline = function SvgHotelroominline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "hotelroom_inline_svg__Layer_1",
    x: 0,
    y: 0,
    style: {
      enableBackground: "new 0 0 50 50"
    },
    viewBox: "3 0 50 50"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".hotelroom_inline_svg__st1{fill:#00a98f}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hotelroom_inline_svg__XMLID_822_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hotelroom_inline_svg__XMLID_824_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hotelroom_inline_svg__XMLID_845_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hotelroom_inline_svg__XMLID_1758_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hotelroom_inline_svg__XMLID_850_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hotelroom_inline_svg__XMLID_851_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hotelroom_inline_svg__XMLID_852_",
    d: "M26.1 22.4v3.5h1v-2.5h5.8v2.5h1v-3.5h-7.8z",
    className: "hotelroom_inline_svg__st1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "hotelroom_inline_svg__XMLID_866_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hotelroom_inline_svg__XMLID_867_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hotelroom_inline_svg__XMLID_868_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hotelroom_inline_svg__XMLID_869_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hotelroom_inline_svg__XMLID_870_",
    d: "M24.3 16.5h1.3v1.3h-1.3z",
    className: "hotelroom_inline_svg__st1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "hotelroom_inline_svg__XMLID_886_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hotelroom_inline_svg__XMLID_887_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hotelroom_inline_svg__XMLID_888_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hotelroom_inline_svg__XMLID_889_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hotelroom_inline_svg__XMLID_890_",
    d: "M22.2 18.9h1.3v1.3h-1.3z",
    className: "hotelroom_inline_svg__st1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "hotelroom_inline_svg__XMLID_896_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hotelroom_inline_svg__XMLID_897_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hotelroom_inline_svg__XMLID_898_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hotelroom_inline_svg__XMLID_899_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "hotelroom_inline_svg__XMLID_900_",
    d: "M31.4 18.9h1.3v1.3h-1.3z",
    className: "hotelroom_inline_svg__st1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "hotelroom_inline_svg__XMLID_901_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hotelroom_inline_svg__XMLID_1754_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hotelroom_inline_svg__XMLID_903_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hotelroom_inline_svg__XMLID_904_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 33.4c0-1.1-.7-2-1.6-2.3V16.8c0-1.8-1.5-3.2-3.4-3.2H14c-1.9 0-3.4 1.4-3.4 3.2v14.3c-.9.3-1.6 1.2-1.6 2.3 0 1.2.8 2.2 2 2.4-.3.4-.3 1 .1 1.3.2.2.4.3.7.3.3 0 .5-.1.7-.3l1.3-1.3h22.5l1.3 1.3c.2.2.4.3.7.3.3 0 .5-.1.7-.3.4-.4.4-.9.1-1.3 1.1-.2 1.9-1.2 1.9-2.4zM12.6 16.8c0-.7.7-1.2 1.4-1.2h22c.8 0 1.4.5 1.4 1.2V31h-.7c.1-.2.1-.3.1-.5v-2.6c0-1.1-.9-2-2-2H23.9v-3.5h-7.8v3.5h-.9c-1.1 0-2 .9-2 2v2.6c0 .2 0 .3.1.5h-.7V16.8zm4.5 9.1v-2.5h5.8v2.5h-5.8zm4.7 1L20 28.7l-1.8-1.8h3.6zM20 30.1l3.2-3.2h11.5c.6 0 1 .4 1 1v2.6c0 .2-.1.3-.1.5H14.4c-.1-.2-.1-.3-.1-.5v-2.6c0-.6.4-1 1-1h1.6l3.1 3.2zm18.5 3.8h-27c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h27.1c.3 0 .5.2.5.5-.1.3-.3.5-.6.5z",
    className: "hotelroom_inline_svg__st1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3 16.5h1.3v1.3h-1.3zM17.5 18.9h1.3v1.3h-1.3zM19.8 16.5h1.3v1.3h-1.3zM26.8 18.9h1.3v1.3h-1.3zM28.9 16.5h1.3v1.3h-1.3zM33.4 16.5h1.3v1.3h-1.3z",
    className: "hotelroom_inline_svg__st1"
  })))))))));
};
export default SvgHotelroominline;